import { RouteConfig } from "vue-router";

export const RExpertTemplateCoverLetter: RouteConfig = {
  path: "cover_letter/:tabTypeId(\\d+)",
  component: () =>
    import(
      /* webpackChunkName: "expert-template-cover-letter" */
      "./VTemplateCoverLetter.vue"
    ),
  meta: {
    label: "Cover Letter",
    tabName: "cover_letter",
  },
};
